import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import * as r from '../../constants/routes';
import { setd_liv69 } from '../slices/appStateSlice';

const setHeaders = (headers: Headers) => {
    headers.set('Content-Type', 'application/json');
    headers.set('x-applicat-apikey', process.env.REACT_APP_API_KEY!);
    return headers;
};

const baseQueryInterceptor: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError,
    {},
    FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);
    if (result.data) {
        const authorizations = (result.data as any).authorization;
        const d_liv69 = authorizations.find((a: any) => a.functName === "d_liv69") ? authorizations.find((a: any) => a.functName === "d_liv69") : {}
        api.dispatch(setd_liv69(d_liv69));
    }

    return result
}

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
        return setHeaders(headers);
    }
});

export const loginApi = createApi({
    reducerPath: 'loginApi',
    baseQuery: baseQueryInterceptor,
    endpoints: (builder) => ({
        loginWithCredentials: builder.mutation({
            query: ({ user, password, impersonate }) => ({ url: `${r.LOGIN}?modules=agence${impersonate ? '&impersonate=' + impersonate : ''}`, method: 'POST', body: { user, password } }),
            transformResponse: (apiResponse, meta) => {
                return { body: apiResponse, headers: meta!.response!.headers };
            }
        }),
        loginWithToken: builder.query({
            query: (token) => (`${r.LOGIN}/${token}?modules=agence`),
            transformResponse: (apiResponse, meta) => {
                return { body: apiResponse, headers: meta!.response!.headers };
            }
        }),
    })
});

export const { useLoginWithCredentialsMutation, useLazyLoginWithTokenQuery } = loginApi;